import * as R from "ramda";
import deserializeQuery from "./deserializeQuery";

function removeParams(names, query) {
  if (typeof query === "string") {
    query = deserializeQuery(query);
  }

  return R.compose(
    R.reduce((acc, key) => {
      if (names.includes(key)) {
        return acc;
      }

      return {
        ...acc,
        [key]: query[key],
      };
    }, {}),
    R.keys
  )(query);
}

export default R.curry(removeParams);



// WEBPACK FOOTER //
// ./utils/removeParams.js